import { useEffect, useState } from 'react';
import { ToastData } from '../../../../../../components/blackrock/advisor-center/toast/model';
import { MAIN_NAV_TOASTER_CREATE_EVENT } from './config';

/**
 * It receives custom events for Toaster and provide data as return value.
 * @returns {array}
 */
const useToastCreate = (): [ToastData | null, () => void] => {
	const [data, setData] = useState<ToastData | null>();

	useEffect(() => {
		const handleCreateEvent = (e: CustomEvent<ToastData>) => {
			setData(e.detail);
		};

		// eslint-disable-next-line @typescript-eslint/ban-ts-comment
		// @ts-ignore
		window.addEventListener(MAIN_NAV_TOASTER_CREATE_EVENT, handleCreateEvent);

		return () => {
			// eslint-disable-next-line @typescript-eslint/ban-ts-comment
			// @ts-ignore
			window.removeEventListener(
				MAIN_NAV_TOASTER_CREATE_EVENT,
				handleCreateEvent
			);
		};
	}, []);

	const resetToast = () => {
		setData(null);
	};

	// eslint-disable-next-line @typescript-eslint/ban-ts-comment
	// @ts-ignore
	return [data, resetToast];
};

export default useToastCreate;
